module.exports = __webpack_public_path__ + "img/arrow-narrow-right_1.e00a5080.svg";